export const ENROLLMENT_STATUS = {
  ENROLLED: "100",
  PENDING: "150",
  NOT_ENROLLED: "200",
};
